import { Box, Button, Card, CardContent, Typography, TextField, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material'
import React from 'react'
import { useNavigate } from 'react-router-dom';

// ICON
import TaskIcon from '@mui/icons-material/Task';
import DownloadIcon from '@mui/icons-material/Download';
import ContentPasteGoIcon from '@mui/icons-material/ContentPasteGo';
import SearchIcon from '@mui/icons-material/Search';

const cardBodyStyle = {
  border: ' grey',
  background: '#fafaeb',
  textAlign: 'center',
  m: 2,
  width: '90%',
}

export default function TrackDocHome() {
  const navigate = useNavigate();
  return (
    <Box className='otherSide' id="otherSide">
      <Box className='surveyLayouts' id="surveyLayouts">
        <Card sx={cardBodyStyle}>
          <CardContent >
            <Typography variant='h5'>ทะเบียนคุมซองเอกสารที่ดิน</Typography>
          </CardContent>
          <CardContent >
            <Box mb={2}>
              <Button
                variant="contained"
                color="secondary"
                sx={{ fontSize: '1.2rem', padding: '12px 24px' }}
                onClick={() => navigate('../trackdoc/search')}
              >
                🔎 ค้นหาซอง พิมพ์บาร์โค้ด
              </Button>
            </Box>
            <Box>
              <Button
                variant="contained"
                color="primary"
                sx={{ fontSize: '1.2rem', padding: '12px 24px' }}
                onClick={() => navigate('../trackdoc/receivedoc')}
              >
                📃 รับเอกสาร
              </Button>
            </Box>
          </CardContent>
        </Card>
      </Box>
    </Box >
  )
}
